import React from 'react';
import { MasInformacionForm } from '../MasInformacion';
import { leadsStockPartialData } from '.';

export function StockForm() {
    return <MasInformacionForm updatedFormData={leadsStockPartialData} />;
}
